import { render, staticRenderFns } from "./dataAnalysisManagement.vue?vue&type=template&id=3a9f2aa8&scoped=true"
import script from "./dataAnalysisManagement.vue?vue&type=script&lang=js"
export * from "./dataAnalysisManagement.vue?vue&type=script&lang=js"
import style0 from "./dataAnalysisManagement.vue?vue&type=style&index=0&id=3a9f2aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f2aa8",
  null
  
)

export default component.exports